ScoreTrekBattle.Tournament.GameEditor = (function() {
    var _this, STATUS;

    function resetStatus() {
        STATUS = {
            game: null,
            games: [],
            tournament: null,
            team1: null,
            team2: null,
            gameResult: null,
            gameData: null,
            error: null,
            dialog: null,
            resolve: () => {},
            reject: () => {}
        };
    }
    resetStatus();

    function loadItem(itemType, itemId, checkOptions) {
        if (itemType === 'round') {
            return loadRound(itemId, checkOptions);
        }
        if (itemType === 'group') {
            return loadGroup(itemId, checkOptions);
        }
        return loadGame(itemId, checkOptions);
    }

    function loadRound(roundId, checkOptions) {
        ScoreTrekBattle.View.loading('Tournament.GameEditor.loadRound', true);
        return new Promise(function(resolve, reject) {  
            Api.request(`/battle/game/getRound`, {
                roundId: roundId,
                checkOptions: checkOptions
            }).then(result => {
                if (!result.round) {
                    reject('ROUND_DOES_NOT_EXIST');
                    return;
                }
                if (!result.games || (result.games.length === 0)) {
                    reject('ROUND_GAMES_NOT_EDITABLE');
                    return;
                }
                STATUS.round = result.round;
                STATUS.games = result.games;
                STATUS.game = result.games[0];
                resolve(getCurrentFromGame(STATUS.game));
            }).catch(reject).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.GameEditor.loadRound', false);
            });
        });
    }

    function loadGroup(groupId, checkOptions) {
        ScoreTrekBattle.View.loading('Tournament.GameEditor.loadGroup', true);
        return new Promise(function(resolve, reject) {  
            Api.request(`/battle/game/getGroup`, {
                groupId: groupId,
                checkOptions: checkOptions
            }).then(result => {
                if (!result.group) {
                    reject('GROUP_DOES_NOT_EXIST');
                    return;
                }
                if (!result.games || (result.games.length === 0)) {
                    reject('GROUP_GAMES_NOT_EDITABLE');
                    return;
                }
                STATUS.group = result.group;
                STATUS.games = result.games;
                STATUS.game = result.games[0];
                resolve(getCurrentFromGame(STATUS.game));
            }).catch(reject).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.GameEditor.loadGroup', false);
            });
        });
    }

    function loadGame(gameId, checkOptions) {
        ScoreTrekBattle.View.loading('Tournament.GameEditor.loadGame', true);
        return new Promise(function(resolve, reject) {  
            Api.request(`/battle/game/get`, {
                gameId: gameId,
                checkOptions: checkOptions
            }).then(result => {
                if (!result.game) {
                    reject('TOURNAMENT_GAME_DOES_NOT_EXIST');
                    return;
                }
                STATUS.game = result.game;
                STATUS.tournament = result.tournament || null;
                STATUS.team1 = result.team1 || null;
                STATUS.team2 = result.team2 || null;
                resolve(getCurrentFromGame(STATUS.game));
            }).catch(reject).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.GameEditor.loadGame', false);
            });
        });
    }

    function getCurrentFromGame(game) {
        return {
            target: game ? game.gameTarget || null : null,
            takeLimit: (game && ScoreTrekBattle.Tournament.Preset.Edit.allowTakeLimit(game.gameType)) ? game.takeLimit || null : null,
            timeLimitMinutes: game ? (game.timeLimitMinutes || 0) : 0
        };
    }

    function renderResultEditor() {
        ScoreTrekBattle.Template.render('tournament/edit/gameResult', {
            game: STATUS.game,
            min: (ScoreTrekBattle.CONFIG.gamesWith.negativeResults.indexOf(STATUS.game.gameType) < 0) ? 0 : -99,
            target: (STATUS.game.gameTarget > 0) ? STATUS.game.gameTarget : 0
        }).then(view => {
            Promise.all([
                renderGame(view),
                renderTeams(view)
            ]).then(() => {
                STATUS.dialog = chmDialog({
                    title: __i18n('game/edit/result', {gameName: __i18n('game/name', {number: STATUS.game.number}), gameType: __i18n(`gameType/${STATUS.game.gameType}`)}),
                    content: view.$view,
                    large: true,
                    centerButtons: true,
                    buttons: [
                        {
                            label: __i18n('button/save'),
                            icon: '<i class="fa-solid fa-check"></i>',
                            primary: true,
                            action: () => {
                                view.forms.gameResult.errors();
                                getResult(view).then(result => {
                                    STATUS.dialog.close().then(() => {
                                        STATUS.resolve(result);
                                    });
                                }).catch(error => {
                                    if (Array.isArray(error)) {
                                        view.forms.gameResult.errors(error);
                                        return;
                                    }
                                    STATUS.reject(error);
                                });
                                return false;
                            }
                        },
                        {
                            label: __i18n('button/cancel'),
                            secondary: true,
                            action: () => {
                                STATUS.reject();
                            }
                        }
                    ],
                    onShow: () => {
                        if (!STATUS.error) {
                            setFocus(view);
                        }
                        STATUS.error = null;
                    }
                });
                if (STATUS.error) {
                    chmDialog.error(STATUS.error).then(() => {
                        setFocus(view);
                    });
                }
            }).catch(STATUS.reject);
        });
    }

    function renderTargetEditor(itemType, currentTarget, currentTakeLimit) {
        ScoreTrekBattle.Template.render('tournament/edit/gameTarget', {
            game: STATUS.game,
            min: 1,
            max: 999,
            minTakeLimit: 0,
            maxTakeLimit: 999,
            currentTarget: currentTarget ? parseInt(currentTarget, 10) : 0,
            currentTakeLimit: currentTakeLimit ? parseInt(currentTakeLimit, 10) : 0,
            gameList: `<span class="text-no-wrap color-blue">${STATUS.games.map(game => __i18n('game/name', {number: game.number})).join('</span>, <span class="text-no-wrap color-blue">')}</span>`
        }).then(view => {
            if (itemType === 'game') {
                view.$view.find('[data-id="gameList"]').remove();
            }
            if (currentTakeLimit === null) {
                view.$view.find('[data-id="takeLimitWrapper"]').remove();
            }
            Promise.all([
                renderGame(view)
            ]).then(() => {
                STATUS.dialog = chmDialog({
                    title: __i18n(`game/edit/target/${itemType}`, {
                        gameName: __i18n('game/name', {number: STATUS.game.number}),
                        gameType: __i18n(`gameType/${STATUS.game.gameType}`),
                        roundName: ScoreTrekBattle.Tournament.Live.getRoundName(STATUS.round),
                        groupName: ScoreTrekBattle.Tournament.Live.getGroupName(STATUS.group)
                    }),
                    content: view.$view,
                    large: false,
                    centerButtons: false,
                    buttons: [
                        {
                            label: __i18n('button/save'),
                            icon: '<i class="fa-solid fa-check"></i>',
                            primary: true,
                            action: () => {
                                view.forms.gameResult.errors();
                                getTarget(view).then(result => {
                                    STATUS.dialog.close().then(() => {
                                        STATUS.resolve(result);
                                    });
                                }).catch(error => {
                                    if (Array.isArray(error)) {
                                        view.forms.gameResult.errors(error);
                                        return;
                                    }
                                    STATUS.reject(error);
                                });
                                return false;
                            }
                        },
                        {
                            label: __i18n('button/cancel'),
                            secondary: true,
                            action: () => {
                                STATUS.reject();
                            }
                        }
                    ],
                    onShow: () => {
                        if (!STATUS.error) {
                            setFocus(view);
                        }
                        STATUS.error = null;
                    }
                });
                if (STATUS.error) {
                    chmDialog.error(STATUS.error).then(() => {
                        setFocus(view);
                    });
                }
            }).catch(STATUS.reject);
        });
    }

    function renderTimeLimitEditor(itemType, currentTimeLimit) {
        ScoreTrekBattle.Template.render('tournament/edit/gameTimeLimit', {
            game: STATUS.game,
            minTimeLimit: 0,
            maxTimeLimit: 300,
            currentTimeLimit: currentTimeLimit ? parseInt(currentTimeLimit, 10) : 0,
            gameList: `<span class="text-no-wrap color-blue">${STATUS.games.map(game => __i18n('game/name', {number: game.number})).join('</span>, <span class="text-no-wrap color-blue">')}</span>`
        }).then(view => {
            if (itemType === 'game') {
                view.$view.find('[data-id="gameList"]').remove();
            }
            Promise.all([
                renderGame(view)
            ]).then(() => {
                STATUS.dialog = chmDialog({
                    title: __i18n(`game/edit/timeLimit/${itemType}`, {
                        gameName: __i18n('game/name', {number: STATUS.game.number}),
                        gameType: __i18n(`gameType/${STATUS.game.gameType}`),
                        roundName: ScoreTrekBattle.Tournament.Live.getRoundName(STATUS.round),
                        groupName: ScoreTrekBattle.Tournament.Live.getGroupName(STATUS.group)
                    }),
                    content: view.$view,
                    large: false,
                    centerButtons: false,
                    buttons: [
                        {
                            label: __i18n('button/save'),
                            icon: '<i class="fa-solid fa-check"></i>',
                            primary: true,
                            action: () => {
                                view.forms.gameResult.errors();
                                getTimeLimit(view).then(result => {
                                    STATUS.dialog.close().then(() => {
                                        STATUS.resolve(result);
                                    });
                                }).catch(error => {
                                    if (Array.isArray(error)) {
                                        view.forms.gameResult.errors(error);
                                        return;
                                    }
                                    STATUS.reject(error);
                                });
                                return false;
                            }
                        },
                        {
                            label: __i18n('button/cancel'),
                            secondary: true,
                            action: () => {
                                STATUS.reject();
                            }
                        }
                    ],
                    onShow: () => {
                        if (!STATUS.error) {
                            setFocus(view);
                        }
                        STATUS.error = null;
                    }
                });
                if (STATUS.error) {
                    chmDialog.error(STATUS.error).then(() => {
                        setFocus(view);
                    });
                }
            }).catch(STATUS.reject);
        });
    }

    function setFocus(view) {
        try {
            view.controls.result1.focus();
        } catch(ignore) {}
        try {
            view.controls.gameTarget.focus();
        } catch(ignore) {}
        try {
            view.controls.timeLimitMinutes.focus();
        } catch(ignore) {}
    }

    function getResult(view) {
        return new Promise(function(resolve, reject) {
            var valid, errors, gameResult;

            valid = true;
            gameResult = {};
            errors = [];

            ['result1', 'result2', 'takes1', 'takes2', 'maxBreak1', 'maxBreak2'].forEach(gameKey => {
                var $input, min, max;

                if (!view.controls[gameKey]) {
                    valid = false;
                    return;
                }

                gameResult[gameKey] = parseInt(view.controls[gameKey].get(), 10);

                $input = view.controls[gameKey].$get();

                min = parseInt($input.attr('min'), 10);
                max = parseInt($input.attr('max'), 10);

                if (isNaN(gameResult[gameKey]) || (gameResult[gameKey] < min) || (gameResult[gameKey] > max)) {
                    errors.push({
                        field: gameKey,
                        message: __i18n('error/field/range', {min: min, max: max})
                    });
                }
            });

            if (errors.length > 0) {
                reject(errors);
                return;
            }

            if (!valid) {
                reject('TOURNAMENT_GAME_INVALID_STATE');
                return;
            }

            resolve(gameResult);
        });
    }

    function getTarget(view) {
        return new Promise(function(resolve, reject) {
            var valid, errors, gameData;

            valid = true;
            gameData = {};
            errors = [];

            ['gameTarget', 'takeLimit'].forEach(gameKey => {
                var $input, min, max;

                if (!view.controls[gameKey]) {
                    valid = false;
                    return;
                }

                gameData[gameKey] = parseInt(view.controls[gameKey].get(), 10);

                $input = view.controls[gameKey].$get();

                min = parseInt($input.attr('min'), 10);
                max = parseInt($input.attr('max'), 10);

                if (isNaN(gameData[gameKey]) || (gameData[gameKey] < min) || (gameData[gameKey] > max)) {
                    errors.push({
                        field: gameKey,
                        message: __i18n('error/field/range', {min: min, max: max})
                    });
                }
            });

            if (errors.length > 0) {
                reject(errors);
                return;
            }

            if (!valid) {
                reject('TOURNAMENT_GAME_INVALID_STATE');
                return;
            }

            resolve(gameData);
        });
    }

    function getTimeLimit(view) {
        return new Promise(function(resolve, reject) {
            var valid, errors, gameData;

            valid = true;
            gameData = {};
            errors = [];

            ['timeLimitMinutes'].forEach(gameKey => {
                var $input, min, max;

                if (!view.controls[gameKey]) {
                    valid = false;
                    return;
                }

                gameData[gameKey] = parseInt(view.controls[gameKey].get(), 10);

                $input = view.controls[gameKey].$get();

                min = parseInt($input.attr('min'), 10);
                max = parseInt($input.attr('max'), 10);

                if (isNaN(gameData[gameKey]) || (gameData[gameKey] < min) || (gameData[gameKey] > max)) {
                    errors.push({
                        field: gameKey,
                        message: __i18n('error/field/range', {min: min, max: max})
                    });
                }
            });

            if (errors.length > 0) {
                reject(errors);
                return;
            }

            if (!valid) {
                reject('TOURNAMENT_GAME_INVALID_STATE');
                return;
            }

            resolve(gameData);
        });
    }

    function renderGame(view) {
        return new Promise(function(resolve, reject) {
            ['result1', 'result2', 'takes1', 'takes2', 'maxBreak1', 'maxBreak2'].forEach(gameKey => {
                if (!view.controls[gameKey]) {
                    return;
                }

                view.controls[gameKey].set(STATUS.gameResult ? STATUS.gameResult[gameKey] : STATUS.game[gameKey]);
                view.controls[gameKey].on('focus', function() {
                    this.select();
                });
            });

            ['gameTarget', 'takeLimit', 'timeLimitMinutes'].forEach(gameKey => {
                if (!view.controls[gameKey]) {
                    return;
                }

                view.controls[gameKey].set(STATUS.gameData ? STATUS.gameData[gameKey] : STATUS.game[gameKey]);
                view.controls[gameKey].on('focus', function() {
                    this.select();
                });
            });

            ['takes', 'maxBreak'].forEach(refKey => {
                if (ScoreTrekBattle.CONFIG.gamesWith[refKey].indexOf(STATUS.game.gameType) < 0) {
                    view.$view.find(`[data-ref="${refKey}"]`).css('display', 'none');
                }
            });

            resolve();
        });
    }

    function renderTeams(view) {
        return new Promise(function(resolve, reject) {
            teamPromises = [];
            ['team1', 'team2'].forEach(teamKey => {
                teamPromises.push(renderTeam(view.$view, STATUS[teamKey]).then($team => {
                    view.$view.find(`[data-id="${teamKey}"]`).empty().append($team);
                }));
            });
            Promise.all(teamPromises).then(() => {
                resolve();
            }).catch(reject);
        });
    }

    function renderTeam($view, team) {
        return new Promise(function(resolve, reject) {
            if (!team) {
                reject('TOURNAMENT_GAME_INVALID_STATE');
                return;
            }

            ScoreTrekBattle.Tournament.Match.renderTeam($view, team, {
                teamSize: getTournament('preset', 'teamSize'),
                toggle: 'disabled',
                allowHighlight: 'no'
            }).then($team => {
                resolve($team);
            }).catch(reject);
        });
    }

    function getTournament(attr, subAttr) {
        if (!STATUS.tournament || !STATUS.tournament.hasOwnProperty(attr)) {
            return null;
        }
        if (subAttr) {
            return STATUS.tournament[attr].hasOwnProperty(subAttr) ? STATUS.tournament[attr][subAttr] : null;
        }
        return STATUS.tournament[attr];
    }

    function editTarget(itemType, itemId, gameData, currentError) {
        return new Promise(function(resolve, reject) {
            resetStatus();
            STATUS.gameData = gameData || null;
            STATUS.error = currentError;
            STATUS.resolve = (result) => {
                resolve(result);
                resetStatus();
            };
            STATUS.reject = (error) => {
                reject(error);
                resetStatus();
            };
            loadItem(itemType, itemId, {hasTarget: true}).then(current => {
                renderTargetEditor(itemType, current.target, current.takeLimit);
            }).catch(reject);
        });
    }

    function editTimeLimit(itemType, itemId, gameData, currentError) {
        return new Promise(function(resolve, reject) {
            resetStatus();
            STATUS.gameData = gameData || null;
            STATUS.error = currentError;
            STATUS.resolve = (result) => {
                resolve(result);
                resetStatus();
            };
            STATUS.reject = (error) => {
                reject(error);
                resetStatus();
            };
            loadItem(itemType, itemId).then(current => {
                renderTimeLimitEditor(itemType, current.timeLimitMinutes);
            }).catch(reject);
        });
    }

    _this = {
        result: function(gameId, gameResult, currentError) {
            return new Promise(function(resolve, reject) {
                resetStatus();
                STATUS.gameResult = gameResult || null;
                STATUS.error = currentError;
                STATUS.resolve = (result) => {
                    resolve(result);
                    resetStatus();
                };
                STATUS.reject = (error) => {
                    reject(error);
                    resetStatus();
                };
                loadGame(gameId).then(renderResultEditor).catch(reject);
            });
        },
        tieResult: function(gameId) {
            return new Promise(function(resolve) {
                let gameResult;

                gameResult = {};

                ['result1', 'result2'].forEach(gameKey => {
                    gameResult[gameKey] = 0;
                });

                ['takes1', 'takes2', 'maxBreak1', 'maxBreak2'].forEach(gameKey => {
                    gameResult[gameKey] = 1;
                });

                resolve(gameResult);
            });
        },
        target: function(gameId, gameData, currentError) {
            return editTarget('game', gameId, gameData, currentError);
        },
        roundTarget: function(roundId, gameData, currentError) {
            return editTarget('round', roundId, gameData, currentError);
        },
        groupTarget: function(groupId, gameData, currentError) {
            return editTarget('group', groupId, gameData, currentError);
        },
        timeLimit: function(gameId, gameData, currentError) {
            return editTimeLimit('game', gameId, gameData, currentError);
        },
        roundTimeLimit: function(roundId, gameData, currentError) {
            return editTimeLimit('round', roundId, gameData, currentError);
        },
        groupTimeLimit: function(groupId, gameData, currentError) {
            return editTimeLimit('group', groupId, gameData, currentError);
        },
        rotationPreview: function(preview) {
            var $content, isIncrease;

            if (!preview || !preview.options || preview.options.length === 0) {
                return;
            }

            isIncrease = preview.newMaxTarget > preview.presetMaxTarget;

            $content = $('<div>').addClass('rotation-preview').css('grid-template-columns', `repeat(${preview.options.length}, 1fr)`);

            preview.options.forEach(function(option) {
                var $col, $header, $target, $games;

                $col    = $('<div>').addClass('rotation-preview-option');
                $header = $('<div>').addClass('rotation-preview-option-header').text(
                    __i18n(`gameType/${option.startType}`)
                );
                $target = $('<div>').addClass('rotation-preview-option-target').append(
                    $('<span>').addClass('color-default').text(option.presetTarget),
                    $('<i>').addClass('fa-solid fa-arrow-right mx-small'),
                    $('<span>').addClass('text-bold').addClass(isIncrease ? 'color-soft-green' : 'color-soft-red').text(option.newTarget)
                );
                $games  = $('<div>').addClass('rotation-preview-option-games');

                var addedStartIndex = isIncrease ? option.games.length - option.addedCount : -1;

                option.games.forEach(function(gameType, index) {
                    var isExisting = !isIncrease || index < addedStartIndex;
                    if (isIncrease && index === addedStartIndex) {
                        $games.append($('<div>').addClass('rotation-preview-divider is-added-divider'));
                    }
                    $games.append(
                        $('<div>').addClass('rotation-preview-game').toggleClass('is-existing', isExisting).append(
                            $('<img>').attr('src', `/res/img/game/${gameType}.svg`)
                        )
                    );
                });

                var hasRemoved = option.removedGames && option.removedGames.length > 0;

                if (hasRemoved) {
                    $games.append($('<div>').addClass('rotation-preview-divider is-removed-divider'));
                    option.removedGames.forEach(function(gameType) {
                        $games.append(
                            $('<div>').addClass('rotation-preview-game is-removed').append(
                                $('<img>').attr('src', `/res/img/game/${gameType}.svg`)
                            )
                        );
                    });
                }

                $col.append($header, $target, $games);
                $content.append($col);
            });

            chmDialog({
                title: __i18n('game/rotation/preview/title'),
                content: $content,
                large: false,
                centerButtons: true,
                buttons: [{
                    label: __i18n('button/gotIt')
                }]
            });
        }
    };

    return _this;
})();